import React from "react";
import styled from "styled-components";
import { Container } from "~/Auth";

export function AuthLoading() {
  return (
    <Container data-testid="auth-loading">
      <Notice>One sec! We're checking your credentials. ⏳</Notice>
    </Container>
  );
}

export const Notice = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;
